import { MatSort } from "@angular/material/sort";
import { ViewerTemplate } from "../../models/media/vet-sale-template.model";
import { MatDataSource } from "../../shared-new/util/mat-datasource";

export class VetSettingsDataSource extends MatDataSource<ViewerTemplate> {

  public constructor(data: ViewerTemplate[], sort: MatSort) {
    super(data, sort,false);
  }

  
}
